export default __webpack_public_path__ + "static/media/tukysa.6309be22.png";